import type { MailboxInfo } from 'owa-client-types';
import { shouldShowInScopeSelector } from 'owa-mail-search-utils';
import type { SearchScope } from 'owa-search-service';
import isGenWebQueryOnTypeEligible from './isGenWebQueryOnTypeEligible';

export default function shouldDisableSuggestionsCallout(
    initialSearchScope: SearchScope,
    staticSearchScope: SearchScope | undefined,
    mailboxInfo: MailboxInfo,
    isQueryOnTypeQfEnabled: boolean
): boolean {
    return (
        !shouldShowInScopeSelector(initialSearchScope) ||
        (isGenWebQueryOnTypeEligible(staticSearchScope, mailboxInfo) && !isQueryOnTypeQfEnabled)
    );
}
